const actions = {
  getUsuario({ commit }) {
    commit("GET_USUARIO");
  },

  setUsuario({ commit }, usuario) {
    commit("SET_USUARIO", usuario);
  },
};

export default actions;
